var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLv = function SvgLv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480.003H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab231d",
    d: "M0 0h640v192.001H0zM0 288.002h640v192.001H0z"
  }))));
};
export default __webpack_public_path__ + "assets/f585c7eca33a1b76e3f8fb9751efa7b6.svg";
export { SvgLv as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/lv.svg